import React, { useState } from 'react'
import { useMessaging } from './MessagingProvider'
import { useMutation } from '@tanstack/react-query'
import { apiPost } from '~/util/api'
import { Button } from '~/lib/ui/button'
import { Input } from '~/lib/ui/input'
import { Textarea } from '~/lib/ui/textarea'
import useTranslation from '../shared/TranslationProvider'

const supportMessagesPath = '/support_messages'

const NewSupportMessage = () => {
  const { t } = useTranslation('CoachMessageThread')
  const { queryClient, clearNewMessageMode, newMessageType } = useMessaging()
  const [newMessageSubject, setNewMessageSubject] = useState('')
  const [newMessageBody, setNewMessageBody] = useState('')

  const postNewMessage = async (request) => {
    const response = await apiPost(`${supportMessagesPath}.json`, request)
    return response
  }

  const createMessageMutation = useMutation({
    mutationFn: postNewMessage,
    onSuccess: () => {
      queryClient.invalidateQueries(['sentMessages'])
      setNewMessageSubject('')
      setNewMessageBody('')
      clearNewMessageMode()
      return true
    },
    onError: (error) => {
      console.error('Error creating message:', error)
    },
  })

  const sendMessage = () => {
    const request = {
      support_message: {
        subject: newMessageSubject,
        body: newMessageBody,
        message_type: newMessageType,
      },
    }
    createMessageMutation.mutate(request)
  }

  const cancel = () => {
    clearNewMessageMode()
    setNewMessageSubject('')
    setNewMessageBody('')
  }

  const title = () => {
    if (newMessageType === 'tech_support') {
      return t('message_technical_support')
    } else if (newMessageType === 'feedback') {
      return t('send_feedback')
    } else if (newMessageType === 'coach_support') {
      return t('message_coach_support')
    } else {
      return ''
    }
  }

  return (
    <div className="flex flex-col gap-y-4">
      <h2>{title()}</h2>
      <div>
        <label>{t('subject')}</label>
        <Input
          value={newMessageSubject}
          onChange={(e) => setNewMessageSubject(e.target.value)}
          placeholder={t('enter_subject')}
        />
      </div>
      <div>
        <label>{t('message')}</label>
        <Textarea
          value={newMessageBody}
          onChange={(e) => setNewMessageBody(e.target.value)}
        />
      </div>
      <div className="flex flex-row justify-start gap-x-2">
        <Button onClick={sendMessage} variant="coachcta">
          {t('send')}
        </Button>
        <Button onClick={cancel} variant="outline">
          {t('cancel')}
        </Button>
      </div>
    </div>
  )
}
export default NewSupportMessage
